// default theme prefix
export const ANT_THEME_PREFIX = 'ant'
// isolated theme prefix, used to fix legacy conflicts
export const ANT_THEME_RESET = 'emmacare'

export const ANT_THEME_DASHBOARD_PREFIX = 'emmacare-dashboard'
export const ANT_THEME_TELEMEDICINE_CALL = 'emmacare-telemedicine'
export const ANT_THEME_NEW = 'emmacare-next'

// TODO revisit and drop
export const ANT_THEME_BULK_PAGE_PREFIX = 'bulk-page'
export const ANT_THEME_ACTION_BUTTONS_PREFIX = 'action-buttons'
